import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-external-icon/jb-external-icon.css.ts
var jb_external_icon_css_default = i`:host{display:inline-block;height:var(--icon-size, 18px);width:var(--icon-size, 18px)}svg{fill:rgb(var(--rgb-primary, 20, 30, 85))}@media(forced-colors: active){svg{fill:CanvasText}}`;

export {
  jb_external_icon_css_default
};
